import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, NUMBER, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import EventTemplates from '@/plugins/sdk/resources/Team/EventTemplates'
import Account from '@/plugins/sdk/resources/Account'
import Profile from '@/plugins/sdk/resources/Profile'
import Role from '@/plugins/sdk/resources/Role'
import ShipperSetting from '@/plugins/sdk/resources/ShipperSetting'
import UserMain from '@/plugins/sdk/resources/User/Main'

export default class extends Resource {
  static name = 'team'
  static label = 'name'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      code: new STRING(),
      description: new STRING(),
      pivot_hide_services_count: new NUMBER(),
      pivot_no_autobooks_count: new NUMBER(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      account: new ITEM(Account),
      profiles: new COLLECTION(Profile),
      role: new ITEM(Role),
      roles: new COLLECTION(Role),
      shipper_setting: new ITEM(ShipperSetting),
      legacy: new ITEM(UserMain),
      open360_only: new BOOLEAN(),
      show_as_cost_center: new BOOLEAN(),
      event_templates: new ITEM(EventTemplates)
    }
  }
}
